import { Injectable } from '@angular/core';
import { CalendarIDs } from '../../shared/enums/calendar-ids.enum';

@Injectable({
  providedIn: 'root'
})
export class ElementIdHelperService {

    constructor() { }

    getActivityElementClassName(activityScheduleId: number, activityProgressStatusId: number): string {
        let scheduleIdClassName = this.getActivityIdentifierClassName(activityScheduleId, 'schedule-activity');
        let progressStatusClassNameId = this.getStatusClassName(activityProgressStatusId, 'progress-status');

        return scheduleIdClassName + '_' + progressStatusClassNameId;
    }

    getCalendarRecordElementClassName(calendarId: number, recordData: any): string {
        let activityIdClassName: string = '';
        let statusClassNameId: string = '';

        switch (calendarId) {

            case (CalendarIDs.OvertimeCalendarForSupervisor):
            case (CalendarIDs.OvertimeCalendarForHusbandry):
                activityIdClassName = this.getActivityIdentifierClassName(recordData.PK_RSOT, 'overtime-activity');
                statusClassNameId = this.getStatusClassName(recordData.PK_RSSTAT, 'overtime-status');

                break;

            case (CalendarIDs.PTOCalendarForSupervisor):
            case (CalendarIDs.PTOCalendarForHusbandry):
                activityIdClassName = this.getActivityIdentifierClassName(recordData.PK_RSPTO, 'pto-activity');
                statusClassNameId = this.getStatusClassName(recordData.PK_RSSTAT, 'pto-status');

                break;

            default:
                return '';
        }

        return activityIdClassName + '_' + statusClassNameId;
    }

    private getStatusClassName(schedulingStatusId: number, statusLabel: string = 'status'): string {
        return statusLabel + '-' + + schedulingStatusId;
    }

    private getActivityIdentifierClassName(activityScheduleId: number, identifierLabel: string = 'activity'): string {
        return identifierLabel + '-' + activityScheduleId;
    }
}
